__turbopack_context__.v({
  "contentContainer": "ClosingSection-module__JReGyq__contentContainer",
  "ctaWrapper": "ClosingSection-module__JReGyq__ctaWrapper",
  "heading": "ClosingSection-module__JReGyq__heading",
  "imageWrapper": "ClosingSection-module__JReGyq__imageWrapper",
  "productImage": "ClosingSection-module__JReGyq__productImage",
  "section": "ClosingSection-module__JReGyq__section",
});
